export const convertApiResponse = (apiResponse) => {
  // Ensure input is always treated as an array
  const responses = Array.isArray(apiResponse) ? apiResponse : [apiResponse];

  let result = [];

  responses.forEach((response) => {
    // Check if message_content contains the split marker
    if (
      response?.message_content &&
      response.message_content.includes("#$%^")
    ) {
      // Split the content by the marker
      const contentParts = response.message_content
        .split("#$%^")
        .map((part) => part.trim());

      // Create entries for each content part
      contentParts.forEach((content, index) => {
        const isLastPart = index === contentParts.length - 1;

        result.push({
          role: "system",
          content: {
            desc: content,
            // Only add options to the last part
            options: isLastPart
              ? (response.message_options || []).map((option) => ({
                  type: option?.type || "nonLink",
                  label: option?.text || "",
                }))
              : [],
          },
          question_id: response?.question_id,
          message_type: response?.message_type,
          action_text: isLastPart ? response?.action_text || "" : undefined,
          startAssessment: response?.startAssessment || "",
          nextCategoryId: response?.nextCategoryId || "",
          isSurvey: true,
          userStory: response?.userStory,
          load_chat: response?.load_chat,
          max_ans_count: isLastPart ? response?.max_ans_count : undefined,
          min_ans_count: isLastPart ? response?.min_ans_count : undefined,
          add_relation: isLastPart ? response?.add_relation : undefined,
          isLastPart: isLastPart ? true : false,
        });
      });
    } else {
      // Handle normal response without splitting
      result.push({
        role: "system",
        content: {
          desc: response?.message_content || null,
          options: (response.message_options || []).map((option) => ({
            type: option?.type || "nonLink",
            label: option?.text || "",
          })),
        },
        question_id: response?.question_id,
        message_type: response?.message_type,
        action_text: response?.action_text || "",
        startAssessment: response?.startAssessment || "",
        nextCategoryId: response?.nextCategoryId || "",
        isSurvey: true,
        userStory: response?.userStory,
        load_chat: response?.load_chat,
        max_ans_count: response?.max_ans_count,
        min_ans_count: response?.min_ans_count,
        add_relation: response?.add_relation,
      });
    }
  });

  return result;
};
